// Буквы слова МИОПИЯ (уникальные), порядок отображения баланса и набора
export const LETTERS = ["М", "И", "О", "П", "Я"]

// Количество букв в одном наборе для сборки бонуса
export const BONUS_SET_SIZE = 6
